import React, { useState } from "react";
import { Table, Row, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import CustomFormCheck from "utils/CustomFormCheck";
import CustomTooltip from "utils/CustomTooltip";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function ManualDataPull(props) {
  const [isEnabled, setIsEnabled] = useState(props.isEnabled);
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Please authenticate shopify url first at account config/website and permissions first.
    </Tooltip>
  );
  const calendarForm = (name, defaultDate) => {
    const [open, setOpen] = useState(false);
    const [startDate, setStartDate] = useState(defaultDate ? defaultDate : new Date());

    const formatDate = (date) => {
      return moment(date).format("YYYYMMDD");
    };

    return (
      <>
        <div className="d-flex data-pull">
          <label className="dateSelectorPull">
            <i style={{ paddingRight: "8px" }} className="far f20 fa-calendar-alt"></i>
            <DatePicker
              dateFormat="MM/dd/yy"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              onClick={() => setOpen(!open)}
              popperProps={{
                positionFixed: true,
              }}
            />
          </label>
          <input hidden readOnly name={`[pull_platform_data][${props.service}]${name}`} value={formatDate(startDate)} />
        </div>
      </>
    );
  };

  return (
    <div className="dataPull">
      <Row className="pl-5 py-3 align-items-center">
        <CustomFormCheck
          id={`data-pull-enabled-${props.service}`}
          name={`data_pull_enabled_${props.service}`}
          checked={isEnabled}
          sendUncheckedValue
          onChange={() => {
            setIsEnabled(!isEnabled);
          }}
          label="Enable Manual Data Pulls"
        />
        <CustomTooltip
          faClass="far f16 primary fa-question-circle pl-2"
          message=" Here you can manually pull data into DataPulse. Select which platforms you would like to pull from and select a date range. Then click Pull Data to import any new available data.
          "
          inline={true}
        />
      </Row>
      {props.platforms.map((platform) => {
        return (
          <Row key={platform.id} className="pl-5 ml-2 pb-1 align-items-center">
            {
              (platform.name =
                "shopify" && props.shopify_token == null ? (
                  <OverlayTrigger placement="right" delay={{ show: 250, hide: 400 }} overlay={renderTooltip}>
                    <CustomFormCheck id={platform.id} label={platform.label} disabled={true} />
                  </OverlayTrigger>
                ) : (
                  <CustomFormCheck
                    id={platform.id}
                    name={`[pull_platform_data][${props.service}]${platform.name}`}
                    label={platform.label}
                    disabled={!isEnabled}
                    sendUncheckedValue
                    static
                  />
                ))
            }
          </Row>
        );
      })}

      <Row className="pl-3  pb-2 ">
        <div className="calendarAdjust">
          <div className=" table-responsive">
            <Table className="table-fixed">
              <tbody>
                <tr className="pl-3">
                  <td className="pl-2 calendarCell">
                    <p className="f12 primary" style={{ whiteSpace: "nowrap" }}>
                      {" "}
                      Date range:{" "}
                    </p>
                  </td>
                  <td className="pl-0 calendarCell">{calendarForm("start_date", moment().subtract(30, "days").toDate())}</td>
                  <td className="pl-0 calendarCell">
                    <p className="f12 primary" style={{ whiteSpace: "nowrap" }}>
                      through
                    </p>
                  </td>
                  <td className="pl-0 calendarAdjust">{calendarForm("end_date", moment().subtract(1, "days").toDate())}</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </Row>
      <Row className="pb-3 pl-4">
        <Button className="mt-0 mb-3 ml-4 mr-4 px-5 py-1" size="sm" as="input" type="submit" value="Save changes and pull data" variant="success" />
      </Row>
    </div>
  );
}
